// extracted by mini-css-extract-plugin
export default {"paragraph":"P_paragraph__2dxsk","ellipsis":"P_ellipsis__8F9v0","hover":"P_hover__ietSE"};